import {
  StrictLocalizeFunction,
  localNum,
  useLocalNum,
} from "@faire/web/common/localization/localize";
import { isNotUndefined } from "@faire/web/common/typescriptUtils";
import { useCallback } from "react";

function bpsToPercent(value: undefined): undefined;

function bpsToPercent(value: number): number;

function bpsToPercent(value: number | undefined): number | undefined;

function bpsToPercent(value: number | undefined): number | undefined {
  return isNotUndefined(value) ? Math.floor(value / 100) : undefined;
}

const percentToString = (
  percentage: number,
  strictLocalize: StrictLocalizeFunction
): string =>
  strictLocalize(
    {
      defaultMessage: "{percentageNumber}%",
      description: {
        text: 'A number formatted as a percentage; for example, "50%" or "100%".',
      },
    },
    { percentageNumber: Math.floor(percentage) }
  );

export const bpsToPercentString = (
  bps: number,
  strictLocalize: StrictLocalizeFunction,
  digit?: number
): string => {
  if (isNotUndefined(digit)) {
    return localNum(bps / 10000, {
      style: "percent",
      minimumFractionDigits: digit,
      maximumFractionDigits: digit,
    });
  }
  return percentToString(bpsToPercent(bps), strictLocalize);
};

export const useBpsToPercentString = () => {
  const { localNum } = useLocalNum();

  const bpsToPercentString = useCallback(
    (bps: number, digit?: number) => {
      if (isNotUndefined(digit)) {
        return localNum(bps / 10000, {
          style: "percent",
          minimumFractionDigits: digit,
          maximumFractionDigits: digit,
        });
      }

      return localNum(bps / 10000, { style: "percent" });
    },
    [localNum]
  );

  return { bpsToPercentString };
};
